// Labels pt-BR dos campos canônicos (mesmos nomes do backend)
const FIELD_LABELS: Record<string, string> = {
  description: "Descrição",
  startDate: "Data de início",
  endDate: "Data de término",
  leve: "Leve (qtd)",
  pague: "Pague (qtd)",
  percent: "Percentual de desconto",
  tipo: "Tipo",
  valorDesc: "Valor de desconto",
  statusProm: "Status da promoção",
  tipoDesc: "Tipo de desconto",
  listas: "Qtd. de listas",
};

const formatDate = (value: string | number | null): string => {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [yyyy, mm, dd] = value.split("-");
    return `${dd}/${mm}/${yyyy}`;
  }
  return String(value ?? "-");
};

export function formatFieldValue(
  field: string,
  value: string | number | null
): string {
  if (value === null || value === undefined || value === "") return "-";
  if (field === "startDate" || field === "endDate") return formatDate(value);
  return String(value);
}

export function fieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? field;
}
